import React, { Fragment, useEffect, useRef, useState } from 'react';
import { Transition } from '@headlessui/react';
import ReactDOM from 'react-dom';

const Modal = ({
  children,
  onClose = () => {},
  className,
  dialogPadding,
  isCrashPopup,
  dataElementId,
  dataDescription,
}: {
  children: any;
  onClose: () => void;
  className?: string;
  dialogPadding?: boolean;
  isCrashPopup?: boolean;
  dataElementId?: string;
  dataDescription?: string;
}) => {
  const [portalContainer, setPortalContainer] = useState(
    isCrashPopup
      ? document.getElementById('headlessui-crash-portal')
      : document.getElementById('headlessui-div-portal')
  );
  const modalRef = useRef<HTMLDivElement>(null);

  // Gestisci il focus e gli attributi aria/inert manualmente sull'elemento con id "app"
  useEffect(() => {
    if (!portalContainer && isCrashPopup) {
      setPortalContainer(document.getElementById('headlessui-crash-portal'));
    }
  }, [portalContainer, isCrashPopup]);

  return (
    <>
      {portalContainer &&
        ReactDOM.createPortal(
          <Transition appear show={true} as={Fragment}>
            <div
              role="dialog"
              aria-modal="true"
              tabIndex={-1}
              ref={modalRef}
              className={`${className} RXC_MODAL tw-relative tw-z-50`}
            >
              {/* Overlay */}
              <Transition.Child
                as={Fragment}
                enter="tw-ease-out duration-300"
                enterFrom="tw-opacity-0"
                enterTo="tw-opacity-100"
                leave="tw-ease-in duration-200"
                leaveFrom="tw-opacity-100"
                leaveTo="tw-opacity-0"
              >
                <div className="tw-fixed tw-inset-0 tw-bg-black tw-bg-opacity-50" />
              </Transition.Child>

              {/* Modal container */}
              <div
                className="tw-fixed tw-inset-0 tw-overflow-y-auto"
                role="dialog"
                aria-modal="true"
                aria-labelledby="modal-title"
                aria-describedby="modal-subtitle"
              >
                <div
                  className="RXC_MODAL_OVERLAY tw-flex tw-min-h-full tw-items-center tw-p-4 tw-justify-center"
                  onClick={() => onClose()}
                  onTouchStart={() => onClose()}
                ></div>
                <Transition.Child
                  as={Fragment}
                  enter="tw-ease-out tw-duration-300"
                  enterFrom="tw-opacity-0 tw-scale-95"
                  enterTo="tw-opacity-100 tw-scale-100"
                  leave="tw-ease-in tw-duration-200"
                  leaveFrom="tw-opacity-100 tw-scale-100"
                  leaveTo="tw-opacity-0 tw-scale-95"
                >
                  {/* Contenuto della modale */}
                  <div
                    className={`RXC_MODAL_CONTAINER tw-w-full tw-max-w-4xl tw-p-4 tw-transform tw-overflow-hidden tw-rounded-2xl tw-bg-white tw-shadow-xl tw-transition-all`}
                  >
                    {/* Close button */}
                    <div className="RXC_MODAL_CLOSE_BUTTON tw-flex tw-flex-row tw-justify-end tw-mb-3">
                      <button
                        className={
                          'MODAL_CLOSE_BUTTON tw-z-50' +
                          (dialogPadding ? 'tw-pr-4 tw-pt-4' : '')
                        }
                        onClick={() => onClose()}
                        aria-label="Close modal"
                        data-element-id={dataElementId}
                        data-description={dataDescription}
                        data-analytics_available_call="0"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="21"
                          fill="none"
                        >
                          <g>
                            <path
                              d="M19.75 1.92 18.58.75 10 9.33 1.42.75.25 1.92l8.58 8.58-8.58 8.58 1.17 1.17L10 11.67l8.58 8.58 1.17-1.17-8.58-8.58 8.58-8.58Z"
                              fill="#000"
                            />
                          </g>
                        </svg>
                      </button>
                    </div>

                    {/* Modal content */}
                    {children}
                  </div>
                </Transition.Child>
              </div>
            </div>
          </Transition>,
          portalContainer
        )}
    </>
  );
};

export default Modal;
